export default __webpack_public_path__ + "static/media/moviekwizz.b358a8d5.png";